import { render } from "./Edit.vue?vue&type=template&id=cc2fa258"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script